import React from 'react';
import AdherenceSettingsQueueLimits from 'components/molecules/adherence-settings/queue-limit-table';

import s from './styles.module.scss';

const AdherenceSettingsQueueLimitsPage: React.FC = () => (
  <div className={s.wrapper}>
    <AdherenceSettingsQueueLimits />
  </div>
);

export default AdherenceSettingsQueueLimitsPage;
